export const tourType = {
  newUser: 1,
  newSubscription: 2,
};
